import React from 'react';
import ContactForm from '../../components/contact-form/contact-form.component';
import { ContactPageContainer } from './contage-page.styles';

const ContactPage = () => (
  <ContactPageContainer>
    <ContactForm />
  </ContactPageContainer>
)

export default ContactPage;